import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('people');

export const PERSON_SECTIONS = [
  {
    key: 'basic',
    title: text.modal.sections.basic.title,
    description: text.modal.sections.basic.description,
    icon: 'fa-id-card-o',
  },
  {
    key: 'contact',
    title: text.modal.sections.contact.title,
    description: text.modal.sections.contact.description,
    icon: 'fa-address-book-o',
  },
  {
    key: 'role',
    title: text.modal.sections.role.title,
    description: text.modal.sections.role.description,
    icon: 'fa-sitemap',
  },
  {
    key: 'address',
    title: text.modal.sections.address.title,
    description: text.modal.sections.address.description,
    icon: 'fa-map-marker',
  },
];

export const createInitialPersonForm = () => ({
  first_name: '',
  last_name: '',
  job_title: '',
  birthdate: '',
  email: '',
  cell_phone: '',
  office_phone: '',
  office_phone_ext: '',
  home_phone: '',
  fax: '',
  invoice_mailing: false,
  payments_mailing: false,
  is_debt_contact: false,
  default: false,
  address: '',
  country: null,
  state: null,
  city: '',
  zipcode: '',
});
